<template>
  <div ref="chart" style="height: 40px;"></div>
</template>

<script>
  export default {
    name: "app-keyword-rank-mini-trend",
    props: {
      data: {
        required: true
      }
    },
    data() {
      return {
        chart: null
      }
    },
    watch: {
      dataChart: {
        handler: function ({chart, data}) {
          if (this.chart && data) {
            this.chart.setOption({
              xAxis: {
                data: data.map((item, index) => index)
              },
              series: {
                data: data
              }
            });
          }
        },
        immediate: true
      }
    },
    computed: {
      dataChart() {
        return {
          chart: this.chart,
          data: this.data
        }
      }
    },
    mounted() {
      this.renderChart();
    },
    methods: {
      renderChart() {
        const chartRef = this.$refs.chart;
        if (chartRef) {
          this.chart = this.$echarts.init(chartRef);
          const option = {
            color: ['#1F6EEF'],
            grid: {
              top: 0,
              left: 4,
              right: 4,
              bottom: 2
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'none'
              },
              backgroundColor: '',
              textStyle: {
                color: '#333',
                fontSize: 13,
                fontWeight: 500
              },
              formatter: function (e) {
                const data = e[0];
                return data.data;
              },
              position: function(point, params, dom, rect, size) {
                return [point[0] + 20, point[1] - 10];
              },
            },
            xAxis: {
              show: false,
              type: 'category',
              boundaryGap: false,
              data: []
            },
            yAxis: {
              show: false,
              type: 'value',
              inverse: true,
              splitLine: {
                show: false
              }
            },
            series: {
              data: [],
              type: 'line',
              smooth: true,
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#c8daf7' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#1F6EEF' // 100% 处的颜色
                  }]
                }
              }
            }
          };
          this.chart.setOption(option);
          window.addEventListener("resize", () => {
            this.chart.resize();
          });
          this.$on('hook:destroyed', () => {
            window.removeEventListener("resize", function () {});
          });
        }
      }
    }
  }
</script>

<style scoped>

</style>
